"use client";

import React, { useEffect } from "react";
import "./SlidingPanel.css";

interface SlidingPanelProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  title?: string;
  position?: "right" | "left" | "bottom";
  width?: string; // e.g. '300px' or '90vw'
  disableBackdropClick?: boolean;
}

const SlidingPanel: React.FC<SlidingPanelProps> = ({
  isOpen,
  onClose,
  children,
  title,
  position = "right",
  width = "90vw",
  disableBackdropClick = false,
}) => {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        onClose();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [onClose]);

  return (
    <div className={`sliding-panel-container ${isOpen ? "open" : ""}`}>
      <div
        className="sliding-panel-backdrop"
        onClick={() => !disableBackdropClick && onClose()}
      />

      <div
        className={`sliding-panel sliding-panel-${position}`}
        style={{ width }}
      >
        <div className="sliding-panel-header">
          {title && <h2>{title}</h2>}
          <button className="close-button" onClick={onClose}>
            &times;
          </button>
        </div>

        <div className="sliding-panel-content">
          {children}
        </div>
      </div>
    </div>
  );
};

export default SlidingPanel;
